<template>
  <div :class="$style.wrapper">
    <lv-heading tag="h2" :level="!isMobile ? '3' : '5'">
      {{ $awt('aw.common.faq.title') }}
    </lv-heading>
    <section>
      <lv-heading tag="h3" :level="!isMobile ? '5' : '6'" :class="$style.subheading">
        <lv-icon name="customer-service-40" :size="40" />
        {{ $awt('aw.common.faq.customer_service_title') }}
      </lv-heading>
      <lv-paragraph>
        {{ $awt('aw.common.faq.customer_service_text') }}
      </lv-paragraph>
      <address>
        <ul :class="$style.contact">
          <li v-for="(c, i) in contacts" :key="i" :class="$style.contactItem">
            <lv-icon :name="c.icon" :size="24" />
            <lv-button :href="c.href" styling="link-primary" shrink>
              {{ $awt(c.label) }}
            </lv-button>
          </li>
        </ul>
      </address>
      <lv-heading tag="h3" :level="!isMobile ? '5' : '6'" :class="$style.subheading">
        <lv-icon name="faq-40" :size="40" />
        {{ $awt('aw.common.faq.faq') }}
      </lv-heading>
      <ul :class="$style.faq">
        <li v-for="(faq, i) in faqItems" :key="i">
          <lv-button
            :to="`${$localePath('faq')}#${faq.token}`"
            styling="quarternary-outlined"
            has-icon
            stretch
          >
            <template #default="{ buttonClasses }">
              <lv-icon name="chevron-right-24" :size="24" :class="buttonClasses.buttonRightIcon" />
              <div :class="buttonClasses.buttonLeftText">
                <div :class="$style.textblock">
                  {{ faq.question }}
                </div>
              </div>
            </template>
          </lv-button>
        </li>
      </ul>
      <lv-button styling="primary-outlined" stretch :to="$localePath('faq')">
        {{ $awt('aw.common.faq.all_faqs') }}
      </lv-button>
    </section>
  </div>
</template>

<script setup>
  import { useNuxtApp } from 'nuxt/app';
  import { LvHeading, LvParagraph, LvButton, LvIcon } from '~~/common/components/loginet-vue-shop/index';
  import { useFaqsStore } from '~~/common/stores/faqs';
  import { useUserInterfaceStore } from '~~/common/stores/userInterface';

  defineOptions({
    inheritAttrs: false,
  });
  const { $awt } = useNuxtApp();
  const isMounted = ref(false);
  const contacts = computed(() => [
    {
      icon: 'envelope-24',
      href: `mailto:${$awt('aw.global.contact_email')}`,
      label: 'aw.global.contact_email',
    },
    {
      icon: 'answer-machine-24',
      href: `tel:${$awt('aw.global.contact_phone')}`,
      label: 'aw.global.contact_phone_visible',
    },
  ]);
  const faqs = computed(() => useFaqsStore().items);
  const isMobile = computed(() => {
    return isMounted.value && useUserInterfaceStore().mediaQueries['sm-max'];
  });
  const faqItems = computed(() => {
    // `items` holds FAQ *groups*; the questions live one level down in `group.faqs`.
    return faqs.value.flatMap(group => group.faqs).slice(0, 3);
  });
  onMounted(() => {
    isMounted.value = true;
    useFaqsStore().fetchFaqs();
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.wrapper {
  height: 100%;
  padding: 16px;
  border-radius: 8px;
  background: $color-white;

  @include md() {
    padding: 24px;
  }

}

.contact,
.faq {
  display: grid;
  margin: 0;
  padding: 0;
  padding-bottom: 25px;
  list-style-type: none;
}

.faq {
  gap: 18px;
}

.contact {
  gap: 11px;
  padding-top: 20px;

  &Item {
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
  }
}

.subheading {
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: flex-start;
  gap: 9px;
  padding: 20px 0 15px;
}

.textblock {
  line-height: 24px;
  padding-right: 50px;
}

</style>
